import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import FullScreenLoader from './FullScreenLoader';

function AdminProtectedRoute({ children }) {
  const { currentUser, userRole, loading } = useAuth();

  // Show loader while determining auth state
  if (loading) {
    return <FullScreenLoader />;
  }

  // If not logged in, redirect to login
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  // If user is salon, redirect to salon dashboard
  if (userRole === 'salon') {
    return <Navigate to="/salon/dashboard" replace />;
  }

  // If role is not determined yet or not admin, wait or redirect
  if (userRole !== 'admin') {
    // Role not determined yet, show loader
    return <FullScreenLoader />;
  }

  return children;
}

export default AdminProtectedRoute;
